import styled from 'styled-components';

export const StyledUserNotPermissionContainer = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;

  && .container-text {
    padding: 40px 20px;
    background-color: #f8f9fa;
    border-radius: 20px;
  }
`;
